import { jwtDecode } from "jwt-decode";
import { getRedirecturl, oidcConfig } from "../utils/oidcConfig";
import { generateCodeChallenge } from "../utils/pkce";
import { generateCodeVerifier } from "../utils/pkce";
import { DEFAULT_LANGUAGE } from "../utils/constants";
import api from "../lib/api";

export const getAccessToken = async (code: string, codeVerifier: string) => {
  try {
    const redirectUrl = getRedirecturl() as string;
  
    // For localhost set directly 
    if (redirectUrl === "http://localhost:3000") {

      const access_token = "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImd0eSI6WyJwYXNzd29yZCJdLCJraWQiOiJyWDk3d0dLU1NxdXpVS2NjUFVPS1B1bmwtbXMifQ.eyJhdWQiOiIyZWUyMTdmZi1kYjdiLTRiOWUtOWQ1Ny03MTYyYmZjYjEwZDMiLCJleHAiOjE3NjkwOTIyODAsImlhdCI6MTc2OTA1NjI4MCwiaXNzIjoic2NzZ2xvYmFsc2VydmljZXMuY29tIiwic3ViIjoiMGQ0ZDQ3MGUtYWQ4Ny00OTA3LThmY2EtNGYxZjdkZTI0NWMwIiwianRpIjoiOTM0NDg1MzQtYTYwZi00YWMxLWE1NTgtMDAzZjdhYzhjZTkwIiwiYXV0aGVudGljYXRpb25UeXBlIjoiUEFTU1dPUkQiLCJlbWFpbCI6InVkYXkuZ29zaGlrYSthbmlyYUBtYWFudGljLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJ1ZGF5Lmdvc2hpa2ErYW5pcmFAbWFhbnRpYy5jb20iLCJhcHBsaWNhdGlvbklkIjoiMmVlMjE3ZmYtZGI3Yi00YjllLTlkNTctNzE2MmJmY2IxMGQzIiwicm9sZXMiOlsiQWRtaW4iXSwic2NvcGUiOiJvcGVuaWQiLCJhdXRoX3RpbWUiOjE3NjkwNTYyODAsInRpZCI6ImUwZmVjNTBhLWQ1YmUtMjk4Yi1iZDIzLTc5YmY0NmEyNzI2YSIsImxhc3ROYW1lIjoiTG9nbyBQb3J0YWwgQ3VzdG9tZXIiLCJwcmVmZXJyZWRMYW5ndWFnZSI6ImVuIiwic2FsZXNmb3JjZUlkIjoiMDAzUnQwMDAwMG9zRnV2SUFFIiwiZmlyc3ROYW1lIjoiQW5pcmEifQ.Tk-NjZBxVhitvfyosTjXPj2mtjB8xvApo8U9mW7SuB0Cw5wNK0ZIj6fhdTmuneu2iV2Fujs7fFDZHw-Ox32I3A";
      const expires_in = 35999;
      const userId = "0d4d470e-ad87-4907-8fca-4f1f7de245c0";
      
      localStorage.setItem("userId", userId);
      localStorage.setItem(
        "access_token_expiry",
        (Date.now() + expires_in * 1000).toString()
      );
      const user: any = jwtDecode(access_token);
      return access_token;
    } else {
      const formData = new FormData();
      formData.append("client_id", oidcConfig.client_id);
      formData.append("code_verifier", codeVerifier);
      formData.append("code", code);
      formData.append("redirect_uri", oidcConfig.redirect_uri);
      formData.append("grant_type", "authorization_code");

      const url = "/oauth2/token";

      const { data } = await api.post(url, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const { access_token, expires_in, userId } = data;
      localStorage.setItem("userId", userId);
      localStorage.setItem(
        "access_token_expiry",
        (Date.now() + expires_in * 1000).toString()
      );
      const user: any = jwtDecode(access_token);
      const preferredLanguage: string = user?.preferredLanguage || DEFAULT_LANGUAGE;
      localStorage.setItem('selectedLang', preferredLanguage);
      return access_token;
    }
  } catch (error) {
    console.error("Error fetching token", error);
    throw error;
  }
};

export const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  const logouturl = `${oidcConfig.authority}/oauth2/logout/?client_id=${oidcConfig.client_id}&redirect_uri=${encodeURIComponent(oidcConfig.logout_redirect_uri)}`;
  window.location.href = logouturl;
};

export const login = async () => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  localStorage.setItem("code_verifier", codeVerifier);
  const authorizationUrl = `${oidcConfig.authority}/oauth2/authorize/?client_id=${oidcConfig.client_id}&response_type=code&scope=${oidcConfig.scope}&redirect_uri=${oidcConfig.redirect_uri}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
  window.location.href = authorizationUrl;
};